import Vue from 'vue'
import VueRouter from 'vue-router'

import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn } from '@/auth/utils'
import constants from '@/app-configs/constants'
import cases from './cases'
import debtors from './debtor'
import integrations from './integrations'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'DEBTIA_HOME',
        breadcrumb: [
          {
            text: 'DEBTIA_HOME',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('@/views/profile/Profile.vue'),
      meta: {
        pageTitle: 'DEBTIA_PROFILE',
        breadcrumb: [
          {
            text: 'DEBTIA_PROFILE',
            active: true,
          },
        ],
        action: constants.action.permissionLogin,
        resource: constants.resource.user,
      },
    },
    ...cases,
    ...debtors,
    ...integrations,
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/reset-password/:token',
      name: 'forgot-password',
      component: () => import('@/views/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/402/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
    {
      path: '/newsletter/unsubscribe',
      name: 'newsletter-unsubscription',
      component: () => import('@/views/Subscription.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
        redirectIfLoggedIn: true,
      },
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()
  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }
  const debtorsBelongToCompany = localStorage.getItem('debtorsBelongTo') === 'company'
  if (isLoggedIn && (to.meta.category === 'debtor' && debtorsBelongToCompany)) {
    return next({ name: 'misc-not-authorized' })
  }
  // if (!isLoggedIn) console.log('isLoggedIn', to)
  return next()
})

export default router
